import axios from 'axios';

export const getPosts = () => {
    return axios.get('https://cms.i-design.com.pl/wp-json/wp/v2/posts')
} 